import { useMemo } from "react";

import type { GscKeyword } from "../../../types";

import { getKeywordMetrics } from "./utils";

/**
 * Return data for the metric cards
 * @param keywords are pre-sorted by clicks (desc) from the API, so "first N" = "top N by clicks"
 * @param selectedCount selected number of keywords
 */
export const useKeywordMetrics = (keywords: GscKeyword[], selectedCount: number) => {
    return useMemo(() => getKeywordMetrics(keywords, selectedCount), [keywords, selectedCount]);
};
